import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const SubmissionTypeAPI = {
  getAll: function () {
    return axiosInstance.request({
      method: 'GET',
      url: `/submission-types`,
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getById: function ({ org_id, submission_type_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submission-types/${submission_type_id}`,
    })
  },
  update: function ({ submission_type_id, ...data }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/submission-types/${submission_type_id}`,
      data: data,
    })
  },
  getOrgSubmissionTypes: function (org_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submission-types`,
    })
  },
  updateOrgSubmissionType: function ({ org_id, submission_type_id, is_show }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/submission-types/${submission_type_id}`,
      data: { is_show },
    })
  },
  superAdminGetOrgSubmissionTypes: function ({ org_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/organizations/${org_id}/submission-types`,
    })
  },
  superAdminUpdateOrgSubmissionType: function ({
    org_id,
    submission_type_id,
    is_active,
    payment_type,
    billing_policy,
  }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/super-admin/organizations/${org_id}/submission-types/${submission_type_id}`,
      data: { is_active, payment_type, billing_policy },
    })
  },
  uploadIcon: function (id, file) {
    let formData = new FormData()
    formData.append('file', file)

    axiosInstance.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    return axiosInstance
      .request({
        method: 'POST',
        url: `/submission-types/${id}/icon`,
        data: formData,
        responseType: 'blob',
      })
      .then(res => {
        return { data: new Blob([res.data]) }
      })
  },
  getIcon: function (id) {
    return axiosInstance
      .request({
        method: 'GET',
        url: `/submission-types/${id}/icon`,
        responseType: 'blob',
      })
      .then(res => {
        if (res.data?.type.indexOf('image') === -1) {
          return null
        }
        return { data: new Blob([res.data], { type: res.data?.type }) }
      })
  },
}

const cancelTokenObject = createCancelToken(SubmissionTypeAPI)
export default SubmissionTypeAPI
